import { render } from "./HeadingSearch.vue?vue&type=template&id=6551c890&scoped=true"
import script from "./HeadingSearch.vue?vue&type=script&lang=js"
export * from "./HeadingSearch.vue?vue&type=script&lang=js"

import "./HeadingSearch.vue?vue&type=style&index=0&id=6551c890&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6551c890"]])

export default __exports__